
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateBranchTagEntity } from '../../domain/entities/CreateUpdateBranchTagEntity'
import type { PostPutBranchTagTranslationAdmin } from '@/backend/market'

export class CreateUpdateBranchTagModel extends CreateUpdateBranchTagEntity {
  channelId!: number
  branchIds?: number[]
  isActive: boolean = true
  translations: Array<PostPutBranchTagTranslationAdmin> = []

  constructor(dataDto: CreateUpdateBranchTagEntity) {
    super()
    mapEntityProperties<CreateUpdateBranchTagModel>(this, dataDto,{
      exclude: ['channel', 'branches'],
      map: {
        channelId: dataDto.channel?.id,
        branchIds: dataDto.branches?.map((branch) => branch.id),
      }
    })
  }
}
